import { AddCircle } from "@mui/icons-material"
import { Button } from "@mui/material"
import { useEffect, useState } from 'react'
import { GalleryModal } from '..'
import { useData } from '../../hooks/useData'
import { Image } from '../../shared/models/Image'
import { Months } from '../../shared/types/Months'
import './ImageContainer.scss'

type Props = {
  month: Months
}

export function ImageContainer(props: Props) {
  const { selectedImages, selectImage } = useData()
  const [image, setImage] = useState<Image | undefined>(selectedImages[props.month] || undefined)
  const [openModal, setOpenModal] = useState(false)

  const openGallery = () => {
    setOpenModal(true)
  }

  const handleImageSelection = (image: Image) => {
    selectImage(image, props.month)
  }

  useEffect(() => {
    const currentImage = selectedImages[props.month]
    if(currentImage) setImage(currentImage)
  }, [selectedImages, props.month])

  return (
    <>
      <div className={`image-container bg-${props.month}`} onClick={() => openGallery()}>
        {
          image ? 
            <img src={`${process.env.PUBLIC_URL}/desenhos/${image.filename}.jpg`} alt={`Desenho ${image?.title} feito por ${image?.name}`} /> :
            <Button className="add-image-btn">
              <AddCircle />
            </Button>
        }
      </div>
      <GalleryModal
        open={openModal}
        currentImage={image}
        onClose={() => setOpenModal(false)}
        onConfirm={(image) => handleImageSelection(image)}
      />
    </>
  )
}